<template>
  <div
    v-loading="adMaterialLoading"
    style="border-bottom: 2px solid #ebeef5; padding-bottom: 20px; box-sizing: border-box"
  >
    <div class="pl-[20px] pr-[20px]">
      <el-form
        v-loading="loading"
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        ref="formInline"
      >
        <div class="flex flex-wrap items-center mr-[20px]">
          <div
            class="flex items-center"
            style="margin-right: 20px; margin-bottom: 15px"
          >
            <div class="tit">类型：</div>
            <div>
              <el-select
                v-model="formInline.mediaType"
                size="mini"
                placeholder="请选择"
                style="width: 113px"
                :disabled="mediaTypeDisabled"
              >
                <el-option
                  label="图片"
                  value="IMAGE"
                ></el-option>
                <el-option
                  label="视频"
                  value="VIDEO"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div
            v-for="selectItem in paramList"
            class="flex items-center"
            style="margin-right: 20px; margin-bottom: 15px"
          >
            <div
              class="tit"
              v-if="selectItem && selectItem.name"
            >
              {{ selectItem.name }}：
            </div>

            <el-select
              v-model="formInline[selectItem.key]"
              size="mini"
              clearable
              placeholder="请选择"
              style="width: 113px"
              v-if="selectItem && selectItem.data"
            >
              <el-option
                v-for="item in selectItem.data"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="flex items-center"
            style="margin-right: 20px; margin-bottom: 15px"
          >
            <div class="tit">宽高：</div>
            <el-select
              v-model="formInline.w_h"
              size="mini"
              style="width: 120px"
              clearable
              placeholder="宽*高"
            >
              <el-option
                v-for="item in wHData"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="flex items-center"
            style="margin-right: 20px; margin-bottom: 15px"
          >
            <div
              class="tit"
              style="width: 70px"
            >
              产品ID：
            </div>
            <el-input
              class="c_online_input"
              size="mini"
              placeholder="请输入单个产品ID"
              v-model="proId"
              clearable
              style="width: 208px"
            />
          </div>

          <el-button
            type="primary"
            size="mini"
            style="margin-bottom: 15px"
            @click="handleQuery"
            >查询</el-button
          >
          <el-button
            size="mini"
            style="margin-bottom: 15px"
            @click="reset"
            >重置</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="listWrap">
      <div v-if="mainMenuList.length === 0">
        <el-empty description="暂无数据"></el-empty>
      </div>
      <div v-else>
        <MaterialList
          :mainMenuList="mainMenuList"
          :columnCount="6"
        >
          <template v-slot:default="scope">
            <div
              class="imgWrap relative box-border p-[8px] cursor-pointer shadow-md hover:shadow-lg rounded-[8px]"
              @click.stop="(event) => choose(event, scope.img._id, scope.img)"
            >
              <el-image
                v-if="scope.img.media_type == 'IMAGE'"
                :src="scope.img.url"
                class="w-full h-full"
                fit="contain"
              ></el-image>

              <div
                class="img"
                v-if="scope.img.media_type == 'VIDEO'"
              >
                <video
                  controls
                  class="w-full h-full rounded-[8px]"
                  :src="scope.img.url"
                  :poster="scope.img.thumbUrl"
                  :ref="`video${scope.img._id}`"
                  @play="handlePlay(scope.img._id)"
                ></video>
              </div>
              <span
                class="absolute right-3 top-3"
                :class="[chooseIdList.indexOf(scope.img._id) >= 0 ? 'active' : '']"
                ><i class="el-icon-success"></i
              ></span>
              <p class="text-gray-600 font-bold text-sm mt-1 text-wrap ellipsis-2">
                {{ scope.img.product_id }}#{{ scope.img.product_name }}
              </p>
              <div class="flex items-center justify-between text-gray-400 text-xs mt-1">
                <el-tooltip :content="scope.img.platform">
                  <p class="mr-1 w-32 truncate">来源：{{ scope.img.platform }}</p>
                </el-tooltip>
                <el-popover
                  placement="top-start"
                  width="600"
                  popper-class="myPop"
                  :title="scope.img.product_name"
                  trigger="hover"
                >
                  <show-data :img="scope.img"></show-data>
                  <p
                    class="toSee color-theme"
                    slot="reference"
                  >
                    查看数据
                  </p>
                </el-popover>
              </div>
            </div>
          </template>
        </MaterialList>
      </div>
    </div>
    <div style="margin-top: 15px; display: flex; flex-direction: row-reverse">
      <el-pagination
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="20"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import MaterialList from '../MaterialList/index.vue';
import { getLocalFilterParamApi, ttmediaLocalAdLibApi, postSaveAdFile } from '../../serve/material';
// import { ts_md5_from_url } from '../../components/uploadMaterial/md5';
import { getFileExist } from '../../components/uploadMaterial/alioss';
import ShowData from './showData.vue';
import { cloneDeep } from 'lodash';
export default {
  // 组件名称
  name: 'AdMaterialsChild',
  // 组件参数 接收来自父组件的数据
  props: {
    // 凭证id，外边传进来
    uid: {
      type: String,
      // default: '7343880135126303745',
      default: '',
    },
    // 账户id，外边传进来
    aid: {
      type: String,
      // default: '7239548445868982273',
      default: '',
    },
    // 广告id，外边传进来
    adId: {
      type: String,
      default: '',
    },
    // 推广链接
    lpu: {
      type: String,
      // default: 'https://hoautoo.com/products/16067435159837283949250780',
      default: '',
    },
    productId: {
      type: Number,
      default: '',
    },
    mediaTypeDisabled: {
      type: Boolean,
      default: false,
    },
    platform: {
      type: String,
      default: '',
    },
    mediaType: {
      type: String,
      default: 'IMAGE',
    },
  },
  // 局部注册的组件
  components: { MaterialList, ShowData },
  // 组件状态值
  data() {
    return {
      paramList: [],
      loading: false,
      formInline: {
        mediaType: 'IMAGE',
        searchIds: '',
        video_name: '', // 视频名称
        sale: {
          productId: '',
        },
      },
      wHData: ['1200*628', '640*640', '720*1280', '1080*1920'],
      proId: '',
      page: 1,
      pageSize: 20,
      mainMenuList: [],
      total: 0,
      chooseIdList: [],
      chooseItemList: [],
      adMaterialLoading: false,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    async choose(event, id, img) {
      img.houseOrigin = 'adMaterial';
      event.preventDefault();
      const idIndex = this.chooseIdList.indexOf(id);
      if (idIndex >= 0) {
        this.chooseIdList.splice(idIndex, 1);
        this.chooseItemList.splice(idIndex, 1);
      } else {
        this.chooseIdList.push(id);
        this.chooseItemList.push(img);
      }
    },
    /** 将所有的内容进行个人素材库查询和上传操作 */
    async checkAndUpload() {
      try {
        this.adMaterialLoading = true;
        for (const img of this.chooseItemList) {
          try {
            img.mediaType = img.media_type;
            // const generatedMd5 = await ts_md5_from_url(img.url);
            const ext = (img.url.match(/\.(\w+)$/)?.[0] || '').replace('.', '');
            // const md5Value = generatedMd5.md5Value;
            const md5Value = img.hashcode || img.md5_code || img.md5;
            const fileRes = await getFileExist(md5Value, ext);

            if (!fileRes) {
              const params = {
                source: 2,
                isAgent: 0,
                fileData: [
                  {
                    ext: '.' + ext,
                    file_name: img.file_name,
                    file_size: img.size,
                    md5_code: md5Value,
                    play_time: '',
                    url: img.url,
                    uid: this.$store.state?.user?.userInfo?.data?.id,
                  },
                ],
              };
              const saveRes = await postSaveAdFile(params);
              img.file_id = saveRes.data[0];
            } else {
              img.file_id = fileRes.id;
            }
          } catch (error) {
            img.status = 'ad-error';
            console.error('error--inner', error);
          }
        }
      } catch (error) {
        console.error('error--outer', error);
      } finally {
        this.adMaterialLoading = false;
        this.$emit('chooseAdMaterial', this.chooseItemList);
      }
    },
    handlePlay(curId) {
      this.mainMenuList.forEach((item) => {
        if (item._id != curId) {
          this.$refs[`video${item._id}`]?.pause();
        }
      });
    },
    async f_getLocalFilterParamApi() {
      try {
        this.loading = true;
        const res = await getLocalFilterParamApi();
        this.paramList = {
          order: res.data.order,
          ...Object.keys(res.data).reduce((result, key) => {
            if (key !== 'order') {
              result[key] = res.data[key];
            }
            return result;
          }, {}),
        };
        for (const obj in this.paramList) {
          if (!this.formInline.hasOwnProperty(obj)) {
            // if (obj == 'order') {
            //   this.$set(this.formInline, obj, this.paramList[obj].data[0].id);
            // } else {
            //   this.$set(this.formInline, obj, '');
            // }
            this.$set(this.formInline, obj, '');
          }
        }
        this.formInline.platform = this.platform;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getList() {
      try {
        const { video_name, ...rest } = this.formInline;
        let newParams = cloneDeep({
          ...rest,
          type: this.formInline.mediaType,
          page: this.page,
          page_size: this.pageSize,
        });
        let obj = {
          uid: this.uid, // 凭证id
          aid: this.aid,
          adId: this.adId,
          lpu: this.lpu,
        };
        newParams.ad_info = obj;
        if (this.proId) {
          newParams.sale.productId = Number(this.proId);
        } else {
          newParams.sale.productId = '';
        }
        this.adMaterialLoading = true;
        const res = await ttmediaLocalAdLibApi(newParams);
        this.mainMenuList = res.data.content;
        this.total = Number(res.data.totalElements) || 0;
        this.mainMenuList.forEach((v) => {
          if (this.formInline.mediaType == 'VIDEO') {
            this.$set(v, 'playFlag', 'notShow');
          }
          const lastDot = v.url.lastIndexOf('.'); // 获取后缀名的索引
          const ext = v.url.substring(lastDot + 1); // 获取后缀名
          const fullName = v.product_name + '.' + ext;
          this.$set(v, 'file_name', fullName);
          const newName = this.$store.state?.user?.userInfo?.data?.id + '#' + this.$store.state?.user?.userInfo?.data?.name + '#' + v.product_name;
          this.$set(v, 'originalFilename', newName);
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.adMaterialLoading = false;
      }
    },
    handleCurrentChange() {
      this.getList();
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    reset() {
      Object.keys(this.formInline).forEach((key) => {
        if (key === 'sale') {
          this.formInline[key].productId = this.productId;
        } else if (key === 'mediaType') {
          this.formInline.mediaType = this.mediaType;
        } else {
          this.formInline[key] = '';
        }
      });
      this.page = 1;
      this.getList();
    },
    handlePlay(curId) {
      this.mainMenuList.forEach((item) => {
        if (item._id != curId) {
          this.$refs[`video${item._id}`]?.pause();
        }
      });
    },
  },
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  async mounted() {
    this.proId = this.productId;
    this.formInline.mediaType = this.mediaType;
    await this.f_getLocalFilterParamApi();
    await this.getList();
  },
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {},
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->
<style scoped lang="scss">
.imgWrap {
  background-color: #f5f5f5;

  &:hover {
    span {
      i {
        opacity: 0.6;
      }
    }
  }
  .el-image {
    min-height: 100px;
  }
  video {
    min-height: 233px;
  }

  span {
    &.active {
      i {
        color: #409eff;
        opacity: 1;
      }
    }

    i {
      font-size: 24px;
      color: #999;
      opacity: 0;
    }
  }
}
.tit {
  color: #666;
  font-size: 14px;
  width: 50px;
}
.imgWrap {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 8px;

  &:hover {
    span {
      i {
        opacity: 0.6;
      }
    }
  }
  .el-image {
    min-height: 100px;
  }
  video {
    min-height: 233px;
  }

  span {
    &.active {
      i {
        color: #409eff;
        opacity: 1;
      }
    }

    i {
      font-size: 24px;
      color: #999;
      opacity: 0;
    }
  }
}
.listWrap {
  height: calc(100vh - 298px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
